var ContentComponent = /** @class */ (function () {
    /**
     * Constructor
     */
    function ContentComponent() {
    }
    return ContentComponent;
}());
export { ContentComponent };
